import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";
import errMsg from "../../services/errMsg";

export const fetchOfflineCompanies = createAsyncThunk(
  "offline/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { append, ...rest } = params;
      const { data } = await api.get(`/companies/offline`, { params: rest });
      return data.data;
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to load offline companies"));
    }
  }
);

const initialState = {
  items: [],
  pagination: { page: 1, limit: 25, total: 0, pages: 0 },
  meta: { hours: 24, totalLiveCompanies: 0, offlineCount: 0, cutoff: null },
  query: { page: 1, limit: 25, hours: 24, search: "" },
  loading: false,
  refreshedAt: null,
  error: null,
};

const slice = createSlice({
  name: "offline",
  initialState,
  reducers: {
    setQuery(state, { payload }) {
      state.query = { ...state.query, ...payload };
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchOfflineCompanies.pending, (s) => {
      s.loading = true;
      s.error = null;
    })
      .addCase(fetchOfflineCompanies.fulfilled, (s, a) => {
        s.loading = false;
        if (a.meta.arg?.append) {
          // mobile infinite scroll
          const existing = new Set(s.items.map((it) => it._id));
          const fresh = a.payload.items.filter(
            (it) => !existing.has(it._id)
          );
          s.items = [...s.items, ...fresh];
        } else {
          s.items = a.payload.items;
        }
        s.pagination = a.payload.pagination;
        s.meta = a.payload.meta || s.meta;
        s.refreshedAt = new Date().toISOString();
      })
      .addCase(fetchOfflineCompanies.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      });
  },
});

export const { setQuery } = slice.actions;
export default slice.reducer;
